import firebase from 'firebase'
require('firebase/firestore')

var config = process.env.FIREBASE
firebase.initializeApp(config)
const firestore = firebase.firestore()
firestore.settings({
  timestampsInSnapshots: true
})
const storage = firebase.storage()
export {
  firebase,
  firestore,
  storage
}



// WEBPACK FOOTER //
// ./src/api/firebase.js